const properties = {
    id: "standard",
    name: "Standard",
    fonts: {
        custom: {
            families: ["TV 2 Text", "TV 2 Display"],
            urls: ["https://fragments.alpha.tv2.no/common.css"]
        }
    },
    properties: {
        fontFamily: {
            primary: "'TV 2 Text', sans-serif",
            titles: "'TV 2 Display', sans-serif"
        },
        fontSize: {
            small: "0.8rem",
            regular: "1rem",
            medium: "1.1rem",
            large: "1.26rem",
            heading4: "1.2rem",
            heading3: "1.4rem",
            heading2: "1.8rem",
            heading1: "2.2rem"
        },
        fontWeight: {
            regular: "300",
            bold: "600",
            headings: "600"
        },
        lineHeight: {
            small: "1.2",
            regular: "1.6"
        },
        color: {
            base: "#100118",
            contrast: "#ffffff",
            background: "#f4f4f4",
            backgroundContent: "#ffffff",
            backgroundShade: "#efefef",
            backgroundPop: "#ffffff",
            primary: "#6F03FF",
            primaryContrast: "#ffffff",
            accent: "#B2AEFF",
            accentContrast: "#100118",
            success: "#34d896",
            error: "#ff668d",
            warning: "#e4bb40",
            info: "#212DFF",
            attention: "#FBFFCD",
            statusText: "#ffffff",
            link: "#6F03FF",
            border: "#ECECEC"
        },
        spacing: {
            small: "0.357rem",
            regular: "0.714rem",
            medium: "1.42rem",
            large: "2.14rem",
            edges: "2rem",
            edgesMobile: "1rem"
        },
        elementSize: {
            small: "2.57rem",
            regular: "3.42rem",
            big: "4.14rem"
        },
        borderRadius: {
            form: "0rem",
            buttons: "0.5rem",
            content: "0"
        },
        boxShadow: {
            content: "0 5px 15px 1px rgba(var(--color_base), 0.05)",
            pop: "0 5px 20px 1px rgba(var(--color_base), 0.2)"
        },
        input: {
            backgroundColor: "rgba(var(--color_contrast), 1)",
            backgroundColorFocus: "rgba(var(--color_contrast), 1)",
            border: "2px solid rgba(var(--color_base), 0.1)",
            borderFocus: "2px solid rgb(var(--color_primary))",
            borderError: "2px solid rgb(var(--color_error))",
            boxShadowFocus: "0 0 5px 0 rgba(var(--color_primary), 0.3)",
            boxShadowError: "0 0 5px 0 rgba(var(--color_error), 0.3)"
        },
        navMain: {
            backgroundColor: "var(--color_base)",
            foregroundColor: "#ffffff",
            accentColor: "var(--color_primary)"
        },
        navLogo: {
            backgroundColor: "transparent"
        },
        splash: {
            backgroundColor: "var(--color_base)",
            foregroundColor: "var(--color_primaryContrast)"
        },
        navMenuHeading: {
            color: "rgba(var(--color_contrast), 0.2)"
        },
        navMenuItem: {
            labelColor: "rgba(var(--color_contrast), 0.6)",
            iconColor: "rgba(var(--color_contrast), 0.25)"
        },
        menuButton: {
            color: "rgba(var(--color_contrast), 1)"
        },
        cardTitle: {
            actionBorder: "none",
            actionIconColor: "rgba(var(--color_primary), 1)",
            actionPadding: "0.4rem",
            actionBorderRadius: "var(--borderRadius_content"
        },
        callout: {
            borderWidth: "0"
        }
    }
};

export default properties;
